import { render, staticRenderFns } from "./VrstaSuorganizatoraEdit.vue?vue&type=template&id=4ef9807c&scoped=true&"
import script from "./VrstaSuorganizatoraEdit.vue?vue&type=script&lang=js&"
export * from "./VrstaSuorganizatoraEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9807c",
  null
  
)

export default component.exports